<template>
    <Detail :place-id="placeId" :shipping-type="shippingType" :place-type="placeType" />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useRoute } from '#imports'
import Detail from '~/pages/pickupPlace/detail.vue'

const route = useRoute()
const params = route.matched[0].props.default as { [name: string]: string }
const placeId = parseInt(params.id)
const locale = useI18n().locale
const shippingType = locale.value !== 'sk' ? 'DEL_CPOST_NB' : 'DEL_SKPOST'
const placeType = 'post_office'
</script>

<style lang="scss" scoped>
.place-detail-page {
    margin-top: 30px;
}
</style>
